import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';

import thumbnail from '../../../_assets/thumbnail/fm.webp';
import title from '../../../_assets/fm-logo.webp';
import { Breadcrumb, BreadcrumbPath } from '../../../_shared/breadcrumb/Breadcrumb';
import { GameTrailer } from '../common/Game-trailer';

export function FlippinMisfitsGame(): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const breadcrumb: BreadcrumbPath[] = [
    {
      key: 'button.my-account',
      path: '/account/my-account',
    },
    {
      key: 'Flippin Misfits',
      path: '',
    },
  ];

  const back = (): void => {
    history.goBack();
  };

  return (
    <div className='game-container our-game-container'>
      <div className='our-game-background' />
      <img className='game-thumbnail' src={thumbnail} alt='Flippin Misfits Thumbnail' />
      <div className='banner'>
        <button type='button' className='btn btn-secondary back-btn' onClick={back}>
          <ArrowBack className='icon' />
          {t('button.back')}
        </button>
        <Breadcrumb paths={breadcrumb} />
        <img className='title' src={title} alt='title dbd' height={120} />
        <GameTrailer
          websiteUrl='https://www.flippinmisfits.com'
          storesUrls={{
            steam: 'https://store.steampowered.com/app/1765520',
          }}
          youtubeUrl='https://www.youtube.com/embed/svWeDFHNFEg'
          isReleased
        />
      </div>
    </div>
  );
}
